import { useEffect } from 'react';
import './styles.css';

export function SoonModal({ onClose }) {
  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', onKeyDown);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', onKeyDown);
    };
  }, [onClose]);

  return (
    <div className="soonModalBackdrop" role="presentation" onClick={onClose}>
      <div
        className="soonModal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="soon-modal-title"
        onClick={(e) => e.stopPropagation()}
      >
        <button type="button" className="soonModalClose" aria-label="Close" onClick={onClose}>
          ×
        </button>
        <p className="soonModalBadge">Soon</p>
        <h2 id="soon-modal-title" className="soonModalTitle">
          We&apos;re almost there
        </h2>
        <p className="soonModalText">Sign in and registration are coming soon. Check back shortly.</p>
        <button type="button" className="btn btnPrimary soonModalBtn" onClick={onClose}>
          Got it
        </button>
      </div>
    </div>
  );
}
